<!--
 * @Author: likk
 * @Date: 2023-09-04 18:04:50
 * @LastEditTime: 2024-03-22 03:53:18
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 作业需求发布
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-tit">作业需求修改</div>
      <el-form :model="form" :inline="true" :rules="rules" :hide-required-asterisk="true" ref="form" label-width="100px">
        <el-form-item prop="identityType" label="身份类型">
          <el-select v-model="form.identityType" placeholder="请选择">
            <el-option v-for="item in identityTypeList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="ownerName" label="需求方名称">
          <el-input v-model="form.ownerName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="contactPhone" label="联系电话">
          <el-input v-model="form.contactPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="requirementType" label="紧急程度">
          <el-select v-model="form.requirementType" placeholder="请选择">
            <el-option v-for="item in requirementTypeList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="checkedCropType" label="作物类型">
          <el-cascader v-model="form.checkedCropType" :options="cropTypeList" :props="cropProps"></el-cascader>
        </el-form-item>
        <el-form-item prop="workType" label="作业类型">
          <!-- <el-cascader v-model="form.checkedWorkType" :options="workTypeList" :props="workTypeProps"></el-cascader> -->
          <el-select v-model="form.workType" placeholder="请选择">
            <el-option v-for="(item,index) in workTypeList" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="workArea" label="作业面积">
          <el-input type="number" v-model="form.workArea" placeholder="请输入"></el-input>
          <span class="suffix">亩</span>
        </el-form-item>
        <el-form-item prop="workPrice" label="作业单价">
          <el-input type="number" v-model="form.workPrice" placeholder="请输入"></el-input>
          <span class="suffix">元/亩</span>
        </el-form-item>
        <el-form-item prop="workDate" label="作业时间">
          <el-date-picker v-model="form.workDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" 
            value-format="yyyy-MM-dd" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="cropPhotoUrls" label="作物照片" class="w100">
          <el-upload
            :action="'#'"
            accept="image/jpeg,image/gif,image/png"
            :multiple="false"
            :show-file-list="false"
            list-type="picture-card"
            :data="{ xtype: 'ysb_product', type: 'image' }"
            :on-success="handleImgSuccess"
            :http-request="handleCustomUpload"
          >
            <img class="thumb" v-if="form.cropPhotoUrls" :src="form.cropPhotoUrls"/>
            <template v-else>
              <i class="el-icon-plus"></i>
              <span>作物照片</span>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item prop="checkedRegion" label="作业位置" class="w100">
          <el-cascader :options="regionData" :props="props" v-model="form.checkedRegion" placeholder="请选择所在位置" @change="checkedRegionChange"></el-cascader>
        </el-form-item>
        <el-form-item prop="workAddress" label=" " class="w100">
          <p class="address">{{form.workAddress}}<span class="btn-text">点击地图获取位置</span></p>
          <div class="map-box" id="mapDiv"></div>
        </el-form-item>
        <el-form-item prop="workAsk" label="作业要求" class="w100">
          <el-input type="textarea" :rows="5" v-model="form.workAsk" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="foot">
        <el-button type="primary" class="btn-gray" @click="handleReset()">重置</el-button>
        <el-button type="primary" @click="handleIssue()" :loading="loading">修改</el-button>
      </div>
    </div>
  </el-main>
</template>

<script>
  import { uploadImg } from "@/api/uploadImg";
  import TalksMap from "@/utils/initMapTalks.js";
  import * as maptalks from "maptalks";
  import { workDemandModify,cropTree,workTypeByCropId, geocoder, getlatLngByRegionId, workXuqiuDetail, getIdentityType, getRequirementType } from "@/api/gxInfo"
  import regionSeatLibs from 'utils/regionSeatLibs'
  let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
  export default {
    // dicts:['dispatch_identity_type','dispatch_requirement_type'],
    data(){
      var checkePhone = (rule, value, callback) => {
        var reg = /^1\d{10}$/;
        if (!value) {
          callback(new Error('请输入联系电话'));
        }else if(!reg.test(value)){
          callback(new Error('联系电话格式不正确'));
        }else{
          callback()
        }
      }
      return {
        id: "",
        TalksMapDialog: new TalksMap(),
        form:{
          identityType:'',//身份类型
          ownerName:"",//需求方名称
          contactPhone:'',//联系电话
          requirementType:'',//紧急程度
          checkedRegion:[],//[省id，市id，区县id]
          workAddress:'',//详细地址
          checkedCropType:[],//[作物大类id,作物小类id]
          workType:'',//作业类型
          workArea:"",//作业面积
          workPrice:"",//作业单价
          workDate:[],//[作业开始日期，作业结束日期]
          cropPhotoUrls: "",
          lat:'',
          lng:'',
          workAsk:'',//作业要求
        },
        rules:{
          identityType:{ required: true, message: '请选择身份类型', trigger: 'change'},
          ownerName: {required: true, message: '请输入需求方名称', trigger: 'blur'},
          contactPhone:{validator:checkePhone, trigger: 'blur'},
          requirementType:{required: true, message: '请选择紧急程度', trigger: 'change'},
          checkedRegion:{required: true, message: '请选择所在位置', trigger: 'change'},
          workAddress:{ required: true, message: '请选择作业位置', trigger: 'change'},
          checkedCropType:{ required: true, message: '请选择作物类型', trigger: 'change'},
          workType:{required: true, message: '请选择作业类型', trigger: 'change'},
          workArea:{required: true, message: '请输入作业面积', trigger: 'blur'},
          workPrice:{required: true, message: '请输入作业单价', trigger: 'blur'},
          workDate:{ required: true, message: '请选择作业时间', trigger: 'change'},
          cropPhotoUrls: {required: true, message:"请上传作物图片", trigger: "change"}
        },
        cropTypeList:[],//作物类型
        cropProps:{
          label:"name",
          value:"code",
          children:'children'
        },
        workTypeList:[],//作业类型（与作物类型联动）
        regionData,
        props: {
          value: 'i',
          label: 'n',
          children: 'c'
        },
        workTypeProps:{
          label: 'name',
          value: 'code',
          children: 'children'
        },
        pickerOptions:{
          disabledDate:(time) => {
            return time.getTime() < new Date().getTime()-3600*1000*24;
          }
        },
        loading: false,
        identityTypeList: [],
        requirementTypeList: []
      }
    },
    components:{
    },
    watch: {
      ["form.checkedCropType"]:{
        handler(val){
          this.cropTypeChange(val,false)
        },
        immediate:true,
        deep:true
      }
    },
    created(){
      this.getCropTypes();
      this.getIdentityType();
      this.getRequirementType();
    },
    mounted(){
      this.id = this.$route.query.id;
      this.getWorkXuqiuDetail();
      this.mapInit();
    },
    
    methods:{
      /**
       * @Author: likk
       * @description: 获取详情数据-回显
       * @param {*}
       * @return {*}
      */ 
      async getWorkXuqiuDetail(){
        const { data: {result} } = await workXuqiuDetail(this.id);
        // let { workServerInfo,fileList,...data} = result;
        for( let key in this.form){
          let value = "";
          switch(key){
            case "ownerName":
              value = result.ownerPlainName;
              break;
            case "contactPhone":
              value = result.contactPlainPhone;
              break;
            case "identityType": case "requirementType":
              value = `${result[key]}`;
              break;
            case "checkedRegion":
              value = [result.workProvinceId,result.workCityId,result.workCountyId];
              break;
            case "checkedCropType":
              this.cropTypeList.forEach(item => {
                if(item.children.find(itm => itm.code==result.cropType)){
                  value = [item.code,result.cropType]
                }
              })
              break;
            case "workDate":
              value = [result.workBeginDate,result.workEndDate];
              break;
            default:
              value = result[key];
              break;
            
          }
          this.form[key] = value;
        }
        this.TalksMapDialog.map.setCenter({ x:result.lng, y:result.lat})
        this.markerOnClick(result.lng, result.lat);
      },
      /**
     * @Author: likk
     * @description: 自定义上传
     * @param {*}
     * @return {*}
    */ 
    handleCustomUpload(content) {
      uploadImg(content).then((res) => {
          content.onSuccess(res.data);
        }).catch((err) => {
          content.onError(err);
          this.$message.error("服务器异常，请重新上传");
        });
    },
    /**
     * @Author: likk
     * @description: 上传成功
     * @param {*}
     * @return {*}
    */
      handleImgSuccess(file){
        this.form.cropPhotoUrls = file.url;
        this.$refs.form.clearValidate('cropPhotoUrls');
      },
      /**
       * @Author: likk
       * @description:获取全部作物类型数据 
       * @param {*}
       * @return {*}
       */   
      async getCropTypes(){
        const { data:{result} } = await cropTree();
        this.cropTypeList = result || [];
      },  
      async getIdentityType(){
        const { data:{result} } = await getIdentityType();
        this.identityTypeList = result || [];
      },
      async getRequirementType(){
        const { data:{result} } = await getRequirementType();
        this.requirementTypeList = result || [];
      },
      /**
       * @Author: likk
       * @description: 作物类型值切换事件
       * @param {*}
       * @return {*}
       */   
       cropTypeChange(val,flag=true){
        console.log(222,val);
        flag && (this.form.workType = "");
        this.workTypeList = [];
        // 根据code获取id
        let cropId2 = ((this.cropTypeList.find( item => item.code==val[0]).children)
        .find( item => item.code==val[1])).id;
        this.getWorkTypesByCrop(cropId2);
       },   
      /**
       * @Author: likk
       * @description: 根据二级作物类型id获取作业类型数据
       * @param {*}
       * @return {*}
       */
      async getWorkTypesByCrop(cropId2){
        const { data: {result}} = await workTypeByCropId({cropId2});
        this.workTypeList = result || [];
      },       
      /**
       * @Author: likk
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
      mapInit(){
        this.TalksMapDialog.sendThis(this);
        let center = [115.546174, 28.054632];
        this.TalksMapDialog.init("mapDiv", 17, center);
        this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
          this.TalksMapDialog.map
        );
        // 监听地图点击事件
        this.TalksMapDialog.map.on("click", (param) => {
          let lng = Number(param.coordinate.x),lat = Number(param.coordinate.y);
          this.form.lng = lng;
          this.form.lat = lat;
          this.markerOnClick(lng,lat);
          this.getAddressByLngLat(lat,lng,(res) => {
            this.form.workAddress = res.address;
          })
        });
      },
      /**
       * @Author: likk
       * @description: 地图标记点点击事件
       * @param {*}
       * @return {*}
       */    
      markerOnClick(lng,lat){
        this.pic1Marker && this.pic1Marker.clear();
        //向地图上添加自定义标注
        new maptalks.Marker(
          [lng,lat],
          {
            symbol: [
              {
                markerFile: require("@/assets/gx/biaozhu_dingwei.png"),
                markerWidth: 22,
                markerHeight: 32,
                markerOpacity: 1,
              },
            ],
          }
        ).addTo(this.pic1Marker);
      },  
      /**
       * @Author: likk
       * @description: 根据经纬度获取详细地址
       * @param {*}
       * @return {*}
       */   
      async getAddressByLngLat(lat,lng,fn) {
        let coords = lat + "," +lng
        let {data:{result}} = await geocoder({coords:coords});
        fn(result);
      },
      checkedRegionChange(val) {
        this.getRegionLngLat(val[val.length-1]);
      },
      /**
       * @description: 根据地区ip获取地图中心点经纬度
       * @return {*}
      */  
      async getRegionLngLat(regionId) {
        if(regionId){
          const { data: {result}} = await getlatLngByRegionId({ regionId });
          this.TalksMapDialog.map.setCenter({ x:result.lng, y:result.lat})
        }
      },  
      /**
       * @Author: likk
       * @description: 发布
       * @param {*}
       * @return {*}
       */  
      handleIssue(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading=true;
            let { checkedCropType, workDate,checkedRegion, ...params } = this.form;
            workDemandModify({
              id:this.id,
              releaseSource:'',
              ...params,
              cropParentType:checkedCropType[0] || '',
              cropType:checkedCropType[1] || '',
              workBeginDate:workDate[0] || '',
              workEndDate:workDate[1] || '',
              workProvinceId:checkedRegion[0] || '',
              workCityId:checkedRegion[1] || '',
              workCountyId:checkedRegion[2] || '',
            }).then( () => {
              this.loading = false;
              this.$message.success("修改成功");
              this.$router.push({ path:'/gx-query/xuqiu/list' });
            }).catch( () => {
              this.loading = false;
            })
          }
        })
        
      },
      /**
      * @Author: likk
      * @description: 重置
      * @param {*}
      * @return {*}
      */  
      handleReset(){
        this.$refs.form.resetFields();
        this.workTypeList = [];
        this.pic1Marker && this.pic1Marker.clear();
      }    
           
    }

  
  }
</script>

<style lang="scss" scoped>
  @import "../style.scss";
  .main{
    padding: 0 !important;
    .top-tit{
      height: 56px;
      line-height: 56px;
      font-size: 20px;
      color: #018388;
      font-weight: bold;
      padding: 0 20px;
      border-bottom: 1px solid #EFEFEF;
    }
    ::v-deep .el-form{
      padding: 20px;
      .el-form-item{
        width: 45%;
        .el-input,.el-date-editor{
          width: 300px;
        }
        .suffix{
          font-size: 16px;
          color: #606266;
          margin-left: 4px;
        }
        .address{
          font-size: 16px;
          color: #333333;
          .btn-text{
            color: #018388;
            text-decoration: underline;
            margin-left: 4px;
          }
        }
        &.w100{
          width: 100%;
          .map-box{
            width: 56vw;
            height: 400px;
          }
          .el-textarea{
            width: 56vw;
            
          }
        }
      }
    }
    .foot{
      text-align: center;
      .el-button{
        font-size: 18px;
        padding: 14px 41px;
        margin: 0 10px;
        &.btn-gray{
          background: #DFDFDF;
          border-color: #DFDFDF;
        }
      }
    }
  }
  
</style>